var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({ width: `${_vm.width}px`, height: `${_vm.height}px` })},[_c('canvas',{ref:"canvas",staticClass:"canvas"})])
}
var staticRenderFns = []

export { render, staticRenderFns }